export default "__VITE_ASSET__749871fc__"